export const ADD_PIN_VIEWER_TYPE = "INSPECTION_TYPE_ADD_PIN_VIEWER_TYPE";
export const INSPECTION_GROUP_LAST_SELECTED_VIEW =
  "INSPECTION_GROUP_LAST_SELECTED_VIEW";
export const MAX_KEEP_ADD_PIN_VIEW_ROLE = 100;
export const MAX_KEEP_SELECTED_VIEW_BY_GROUP = 50;
export const INSPECTION_HELP_FLAG = "inspection-help-flag";

export enum INSPECTION_HELP_FLAG_STATE {
  ON = "on",
  OFF = "off",
}
export const INSPECTION_DETAIL_HELP_FLAG = "inspection-detail-help-flag";
export enum INSPECTION_DETAIL_HELP_FLAG_STATE {
  ON = "on",
  OFF = "off",
}
export const INSPECTION_SELECT_TARGET_HELP_FLAG =
  "inspection-select-target-help-flag";
export enum INSPECTION_SELECT_TARGET_HELP_FLAG_STATE {
  ON = "on",
  OFF = "off",
}
